// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const CHECKBOX_SIZE = '25px';

const styles = css`
  align-items: ${(props) => (props.alignCheckbox ? props.alignCheckbox : 'center')};

  & .checkBoxLabelAlign {
    display: flex;
    ${(props) =>
      props.spc &&
      `
    position: relative;
    width: 74px;
    height: 34px;
    border-radius: 20px;
    background: ${props.theme.colors.PRIMARY.LIGHTGRAY};
        `};
    ${(props) =>
      props.input &&
      props.input.value &&
      props.spc &&
      `
          background :${props.theme.colorPalette.blue[800]};`}
  }

  & .labelStyle {
    margin-bottom: 0;
    min-height: 30px;
    display: table;
    margin-top: -3px;

    ${(props) =>
      props.genericCheckboxStyle
        ? `
    width: calc(100% - 37px);`
        : ``}
  }

  & .CheckBox__input {
    ${(props) =>
      !props.spc
        ? ` flex: 0 0 auto;
      position: relative;
      top: 0;
      appearance: none;
      border: 0;
      height: ${CHECKBOX_SIZE};
      width: ${CHECKBOX_SIZE};
      margin: 0;
      margin-right: ${props.theme.spacing.ELEM_SPACING.SM};
      display: inline-block;
      vertical-align: top;
    `
        : `
      width: 100%;
      height: 100%;
      z-index: 1;
      opacity: 0;
    `}
  }

  & .CheckBox__input:before {
    ${(props) =>
      !props.spc &&
      ` content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      border: 1px solid ${props.theme.colors.CHECKBOX.BORDER};`}
  }

  & .CheckBox__input:checked:before {
    ${(props) =>
      !props.spc &&
      ` background: ${props.theme.colors.CHECKBOX.CHECKED_BORDER};
      border: 1px solid ${props.theme.colors.CHECKBOX.CHECKED_BORDER};`}
  }

  & .CheckBox__input:checked:after {
    ${(props) =>
      !props.spc &&
      `transform: rotate(225deg);
      content: '';
      border: 2px solid ${props.theme.colors.CHECKBOX.TICK_COLOR};
      font-size: ${props.theme.fonts.fontSize.body.bodytext.copy2}px;
      width: ${props.theme.spacing.ELEM_SPACING.XXS};
      height: 10px;
      border-right: 0;
      border-bottom: 0;
      left: 10px;
      top: 5px;
      position: absolute;`}
  }

  & .CheckBox__text {
    display: table-cell;
    vertical-align: middle;

    ${(props) =>
      props.isPickUpStoreView
        ? `
    font-size: ${props.theme.typography.fontSizes.fs16};`
        : `font-size: ${props.theme.typography.fontSizes.fs12};`}
  }

  & .CheckBox__text a {
    color: ${(props) => props.theme.colorPalette.black};
  }

  & .disabled {
    opacity: ${(props) => props.theme.opacity.opacity.medium};
  }

  & .Checkbox__error {
    display: flex;
    flex-direction: row;
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  & .warning-icon {
    background: transparent url('${(props) => getIconPath('circle-alert-fill', props)}') no-repeat 0
      0;
    background-size: contain;
    border: none;
    height: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    width: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    margin-right: 4px;
    margin-top: 2px;
  }
  & #checkbox__error__iAgree {
    margin-top: 4px;
  }
  & .indicator {
    height: 22px;
    width: 22px;
    background: ${(props) => props.theme.colorPalette.white};
    position: absolute;
    top: ${(props) => (props.spc ? '6px' : '5px')};
    left: 5px;
    border-radius: 50%;
    transition: left 0.25s ease;
    ${(props) => props.input && props.input.value && `left: 45px;`}
  }

  & .indicator-text {
    position: absolute;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    top: ${(props) => (props.spc ? '7px' : '5px')};
    left: ${(props) => (props.spc ? '36px' : '40px')};
    border-radius: 50%;
    ${(props) =>
      props.input &&
      props.input.value &&
      `left: 12px;
    color: ${props.theme.colorPalette.white};
    `}
    @media (max-width: ${(props) => props.spc && props.theme.breakpoints.smallMax}) {
      color: ${(props) => (props.spc ? props.theme.colorPalette.white : 'transparent')};
    }
  }
`;

export default styles;
